import BrandBlock from './BrandBlock'

export default BrandBlock
